import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { GetData } from "contexts/DataContext";

import React from "react";

export function TypeField(props) {
  const { dataObj, setDataObj } = GetData();

  const [value, setValue] = React.useState(() =>
    dataObj?.payType !== "self-service" ? 0 : 1
  );

  React.useEffect(() => {
    setValue(dataObj?.payType !== "self-service" ? 0 : 1);
  }, [dataObj?.payType]);

  const handleChange = (event, newValue) => {
    let payType = event.target.value === 0 ? "payment" : "self-service";
    setDataObj(payType, "payType");
    setValue(event.target.value);
  };

  return (
    <React.Fragment>
      <FormControl fullWidth variant="standard">
        <InputLabel id="terminal-type-label" sx={{ paddingTop: "6px" }}>
          Режим работы
        </InputLabel>
        <Select
          id="terminal-type-select"
          label="Режим работы"
          labelId="terminal-type-label"
          onChange={handleChange}
          value={value}
        >
          <MenuItem value={0}>Терминал СБП</MenuItem>
          <MenuItem value={1}>Электронный кассир</MenuItem>
        </Select>
      </FormControl>
    </React.Fragment>
  );
}
